export default interface IAddressVm {
    id: string
    postalDistrict: string
    postalCode: string
    countryName: string
    countryCode: string
    combinedStreetAddressLine: string
    isForeignAddress: boolean
    coName: string
    buildingName: string
    buildingNumber: string
    cityName: string
    floor: string
    houseNumberFrom: string
    houseNumberTo: string
    houseLetterFrom: string
    houseLetterTo: string
    municipalityCode: string
    postbox: string
    sideDoor: string
    streetName: string
}

export const empty = (enableIteration: boolean = true): IAddressVm => {
	return {
		id: "",
		postalDistrict: "",
		postalCode: "",
		countryName: "",
		countryCode: "",
		combinedStreetAddressLine: "",
		isForeignAddress: false,
		coName: "",
		buildingName: "",
		buildingNumber: "",
		cityName: "",
		floor: "",
		houseNumberFrom: "",
		houseNumberTo: "",
		houseLetterFrom: "",
		houseLetterTo: "",
		municipalityCode: "",
		postbox: "",
		sideDoor: "",
		streetName: ""
	} as IAddressVm
}